module.exports = __webpack_public_path__ + "static/img/face25.4ff34c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face25.jpg
// module id = sYfD
// module chunks = 0